"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notAnObject = exports.notAnArrayOfLength = exports.notAnArray = exports.notAStringOfLength = exports.notAString = exports.notANumber = exports.notAJsonObject = exports.notAFunction = void 0;
const notAnArray = exports.notAnArray = ["string", 1234, {}, true, null, () => true, new Date(2024, 2, 3)],
  notAnArrayOfLength = exports.notAnArrayOfLength = ["string", 1234, [], {}, true, null, () => true, new Date(2024, 2, 3)],
  notAFunction = exports.notAFunction = ["string", 1234, [], {}, true, null, new Date(2024, 2, 3)],
  notAJsonObject = exports.notAJsonObject = [{
    name: undefined
  }],
  notANumber = exports.notANumber = ["string", [], {}, true, null, () => true, new Date(2024, 2, 3)],
  notAnObject = exports.notAnObject = ["string", 1234, true, () => true],
  notAString = exports.notAString = [1234, [], {}, true, null, () => true, new Date(2024, 2, 3)],
  notAStringOfLength = exports.notAStringOfLength = ["", 1234, [], {}, true, null, () => true, new Date(2024, 2, 3)];